import { useEffect } from 'react';
import type { HydrogenFcfsLeadTimeSettings } from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

export function useHydrogenFcfsLeadTimeSettings(url: string | undefined) {
  const request = useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<HydrogenFcfsLeadTimeSettings>({
        ...baseConfig,
        url,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute(url);
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  if (!url) return;

  return request;
}

export type HydrogenFcfsLeadTimeSettingsRequest = ReturnType<
  typeof useHydrogenFcfsLeadTimeSettings
>;
